import React, { Fragment } from "react";
import {
  Box,
  Backdrop,
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Link,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import DOMPurify from "dompurify";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning"; // For Low Stock
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn"; // For No Stock
import SubdirectoryArrowLeftIcon from "@mui/icons-material/SubdirectoryArrowLeft";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { SouthAfricanRand } from "../../utils/helpers";
import { COLORS } from "../../constants";
import { AccountType, ProductAvailability } from "../../utils/constants";

import TabPanel from "../TabPanel/TabPanel";
import RelatedProducts from "../RelatedProducts/RelatedProducts";
import YouMightAlsoLike from "../YouMightAlsoLike/YouMightAlsoLike";
import ProductTabs from "./ProductTabs";
import DesktopProductInfo from "./DesktopProductInfo";

const DesktopProduct = ({
  pricingData,
  accountType,
  loading,
  handleAddToCartClick,
  productPrice,
  availabilityValue,
  quantity,
  setQuantity,
  numberOfRows,
  handleApplicationFilterClick,
  applicationColumns,
  applicationMakes,
  applicationModels,
  applicationVariants,
  applicationYears,
  applicationFilters,
  setApplicationFilters,
  authError,
  tabValue,
  handleTabChange,
  product,
}) => {
  const sanitizedMarkup = (html) => {
    return { __html: DOMPurify.sanitize(html) };
  };

  return (
    <Fragment>
      <Container sx={{ paddingTop: 3, paddingBottom: 4 }} disableGutters>
        <Box sx={{ mt: 1 }}>
          {product ? (
            <Grid
              container
              spacing={2}
              sx={{ flexDirection: { xs: "column", md: "row" } }}
            >
              <Grid item xs={12} md={8.7}>
                <Grid
                  container
                  xs={12}
                  sx={{
                    backgroundColor: COLORS.white,
                    border: `1px solid ${COLORS.border}`,
                    borderRadius: "2px",
                  }}
                >
                  <DesktopProductInfo
                    product={product}
                    productPrice={productPrice}
                    accountType={accountType}
                    availabilityValue={availabilityValue}
                    quantity={quantity}
                    setQuantity={setQuantity}
                    handleAddToCartClick={handleAddToCartClick}
                  />
                </Grid>

                {/* Tabs Section */}
                <ProductTabs
                  tabValue={tabValue}
                  handleTabChange={handleTabChange}
                  product={product}
                  applicationMakes={applicationMakes}
                  applicationModels={applicationModels}
                  applicationVariants={applicationVariants}
                  applicationYears={applicationYears}
                  applicationFilters={applicationFilters}
                  handleApplicationFilterClick={handleApplicationFilterClick}
                  numberOfRows={numberOfRows}
                  applicationColumns={applicationColumns}
                  authError={authError}
                />

                <Box sx={{ mt: 5 }}>
                  <Box sx={{ height: "32px" }} />
                  {/* <YouMightAlsoLike
                    product={product}
                    pricingData={pricingData}
                  /> */}
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={loading}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
                </Box>
              </Grid>

              {/* Related Products - Right Side (1/5 width) */}
              {/* <Grid item xs={12} md={3.3}>
                <RelatedProducts product={product} pricingData={pricingData} />
              </Grid> */}
            </Grid>
          ) : (
            <Box sx={{ textAlign: "center", marginTop: 4 }}>
              <Typography variant="h6">No product found</Typography>
            </Box>
          )}
        </Box>
      </Container>
    </Fragment>
  );
};

export default DesktopProduct;
